module.exports = __webpack_public_path__ + "static/media/icon-macro-alternate.a804953d.svg";